import styled from 'styled-components';

const SidebarList = styled.div`
    position: sticky;
    top: 75px;
}
`;

export default SidebarList;
